module.exports = __webpack_public_path__ + "static/media/LogoutDark.0a4158fb.svg";